import { takeLatest, select, call } from 'redux-saga/effects';

import { TOKEN_RENEW_FAILED } from '../constants/actionTypes';
import { APP_RENEW_TOKEN_FAILED_HEAP } from '../constants/heapEvents';
import { track } from '../lib/heapHelpers';
import { applicationIdSelector } from '../reducers/selectors';

function* tokenRenewFailedWatcher() {
  yield takeLatest(TOKEN_RENEW_FAILED, tokenRenewFailedWorker);
}

function* tokenRenewFailedWorker() {
  const applicationId = yield select(applicationIdSelector);
  yield call(track, APP_RENEW_TOKEN_FAILED_HEAP, { 'Application GUID': applicationId });
}

export { tokenRenewFailedWorker };
export default tokenRenewFailedWatcher;
